import { render, staticRenderFns } from "./moduleTen.vue?vue&type=template&id=215876bc&scoped=true&"
import script from "./moduleTen.vue?vue&type=script&lang=js&"
export * from "./moduleTen.vue?vue&type=script&lang=js&"
import style0 from "./moduleTen.vue?vue&type=style&index=0&id=215876bc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "215876bc",
  null
  
)

export default component.exports